import type { ContactActivity } from '../typescript-types/contact/contact-activity';

import { ACTIVITY_TYPES } from './activity-types';
import { MESSAGE_TYPE } from './message-types';

export const getSenderName = (activity: ContactActivity, name: SimpleName, orgName: string) => {
  const { user, message } = activity;

  if (activity.isAutomated) {
    if (
      activity.type === ACTIVITY_TYPES.MESSAGE &&
      message &&
      message.type === MESSAGE_TYPE.EMAIL
    ) {
      return orgName;
    }
    return 'Team Engine (automatically)';
  }
  if (user) {
    return `${user.firstName} ${user.lastName}`;
  }

  return `${name.firstName} ${name.lastName}`;
};
